import React from 'react';
import logoMark from '../assets/images/logo-web.png';
import '../assets/css/theme.css';

interface BrandLogoProps {
  /** `light` = white wordmark (for dark backgrounds) */
  tone?: 'light' | 'dark';
}

/** Fashion Frame "F" mark + wordmark. Used by navbar, footer and auth modal. */
const BrandLogo = ({ tone = 'dark' }: BrandLogoProps) => (
  <span className={`ffb-logo ffb-logo--${tone}`}>
    <span className="ffb-logo-mark">
      <img src={logoMark} alt="" />
    </span>
    <span className="ffb-logo-text">Fashion Frame</span>
  </span>
);

export default BrandLogo;